var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQyjcxx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 69",
    className: "design-iconfont",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "98.993048%",
    id: "q0homysfrc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB6F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#227BF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "j3gkyu0mlb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DCFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A2FE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-44%",
    y: "-37%",
    width: "187.9%",
    height: "173.9%",
    filterUnits: "objectBoundingBox",
    id: "jiyro2d3fa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329116928 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#jiyro2d3fa)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,5 C35.3506307,5 41.0997889,7.58913593 45.2614593,11.7744092 C49.4251707,15.9617352 52,21.7466044 52,28.1361163 C52,33.6616494 48.5782888,40.4412816 44.3475291,46.410863 C38.7842583,54.2606113 31.7296255,61 29,61 C26.2703745,61 19.2157417,54.2606113 13.6524709,46.410863 C9.42171119,40.4412816 6,33.6616494 6,28.1361163 C6,21.7466044 8.57482926,15.9617352 12.7385407,11.7744092 C16.9002111,7.58913593 22.6493693,5 29,5 Z",
    stroke: "url(#j3gkyu0mlb)",
    strokeWidth: 2,
    fill: "url(#q0homysfrc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1924436,21.5756404 L35.1924436,37.0125635 C35.1924436,37.1107173 35.2756257,37.191025 35.3772926,37.191025 L36.3939625,37.191025 C36.4960518,37.191025 36.5788115,37.1111251 36.5788115,37.0125635 L36.5788115,23.9848712 C36.5788115,23.8867173 36.6619936,23.8064096 36.7636606,23.8064096 L38.4273022,23.8064096 C39.4481953,23.8064096 40.2757928,24.6054092 40.2757928,25.591025 L40.2757928,37.0125635 C40.2757928,37.1107173 40.3589749,37.191025 40.4606418,37.191025 L41.015189,37.191025 C41.116856,37.191025 41.2000381,37.2713327 41.2000381,37.3694865 L41.2000381,38.7971789 C41.2000381,38.8957404 41.1172783,38.9756404 41.015189,38.9756404 L19.2029997,38.9756404 C19.1009104,38.9756404 19.0181506,38.8957404 19.0181506,38.7971789 L19.0181506,37.3694865 C19.0181506,37.2713327 19.1013327,37.191025 19.2029997,37.191025 L20.2196695,37.191025 C20.3217589,37.191025 20.4045186,37.1111251 20.4045186,37.0125635 L20.4045186,21.5756404 C20.4045186,20.0972166 21.6459148,18.8987173 23.1772546,18.8987173 L32.4197076,18.8987173 C33.9510474,18.8987173 35.1924436,20.0972166 35.1924436,21.5756404 Z M29.9823407,27.8217943 L25.7994705,27.8217943 C25.7294664,27.8217943 25.6727169,27.9549609 25.6727169,28.1192302 L25.6727169,29.7551276 C25.6727169,29.9187173 25.729756,30.0525635 25.7994705,30.0525635 L29.9823407,30.0525635 C30.0523448,30.0525635 30.1090944,29.9193969 30.1090944,29.7551276 L30.1090944,28.1192302 C30.1090944,27.9549608 30.0523448,27.8217943 29.9823407,27.8217943 L29.9823407,27.8217943 Z M32.149828,23.3602558 L23.6319832,23.3602558 C23.5339775,23.3602558 23.4545281,23.4934224 23.4545281,23.6576917 L23.4545281,25.2935891 C23.4545281,25.4571788 23.5343829,25.591025 23.6319832,25.591025 L32.149828,25.591025 C32.2478338,25.591025 32.3272831,25.4578584 32.3272831,25.2935891 L32.3272831,23.6576917 C32.3272831,23.4934224 32.2478338,23.3602558 32.149828,23.3602558 L32.149828,23.3602558 Z",
    fill: "#E2F2FF",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQyjcxx);
export default __webpack_public_path__ + "static/media/qyjcxx.379557561cf1b6c974551c84b3c481fb.svg";
export { ForwardRef as ReactComponent };